import React, { FC, useLayoutEffect, useRef } from 'react';

export interface QuickViewVideoProps {
  src: string;
  isLoadDeferred?: boolean;
  className?: string;
}

export const QuickViewVideo: FC<QuickViewVideoProps> = ({
  src,
  className,
  isLoadDeferred,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useLayoutEffect(() => {
    const video = videoRef.current;
    const handleVideoError = (error: ErrorEvent) => {
      console.error(error);
      window?.Sentry?.captureException(error);
    };

    if (video) {
      video.addEventListener('error', handleVideoError);
    }

    return () => {
      if (video) {
        video.removeEventListener('error', handleVideoError);
      }
    };
  }, []);

  return (
    <video
      src={isLoadDeferred ? undefined : `${src}#t=0.1`}
      className={className}
      preload="metadata"
      ref={videoRef}
      muted
      autoPlay
      loop
      playsInline
    />
  );
};
